<template>
  <aside id="fa-side-nav" class="load-anim">
    <p id="nav-head">Learn More About</p>
    <nav class="side-nav">
      <ul>
        <li>
          <a
            href="#advisory-services"
            @click.prevent="scrollLink('#advisory-services')"
            >Our Approach</a
          >
        </li>
        <li>
          <a
            href="#industry-focus"
            @click.prevent="scrollLink('#industry-focus')"
            >Industry Focus</a
          >
        </li>
        <li>
          <a href="#transactions" @click.prevent="scrollLink('#transactions')"
            >Representative Transactions</a
          >
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
import { gsap } from "gsap";
// eslint-disable-next-line no-unused-vars
import ScrollToPlugin from "gsap/dist/ScrollToPlugin";
export default {
  data() {
    return {
      whiteSectionTop: ""
    };
  },
  methods: {
    scrollLink(target) {
      gsap.to(window, {
        duration: 1,
        scrollTo: target,
        ease: 'power2.out'
      });
    },
    getWhiteTop() {
      this.whiteSectionTop = document.getElementById(
        "advisory-services"
      ).offsetTop;
    },
    updateSideNav() {
      var comp = this;
      var navHead = document.getElementById("nav-head"),
        navOffset = document.getElementById("fa-side-nav").offsetTop;
      window.addEventListener("scroll", function() {
        if (window.scrollY > comp.whiteSectionTop - navOffset) {
          navHead.style.color = "#111d3c";
        } else {
          navHead.style.color = "#ffffff";
        }
      });
    }
  },
  mounted() {
    var comp = this;
    this.getWhiteTop();
    this.updateSideNav();
    window.addEventListener("resize", function() {
      comp.getWhiteTop();
    });
    gsap.registerPlugin(ScrollToPlugin)
  }
};
</script>

<style lang="scss" scoped>
#fa-side-nav {
  position: fixed;
  top: 40%;
  left: 10%;
  @media screen and (max-width: 1200px) {
    left: 48px;
  }
  @media screen and (max-width: 768px) {
    display: none;
  }
}
#nav-head {
  color: #ffffff;
  text-transform: uppercase;
  font-size: 0.875rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
}
.side-nav {
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    li a {
      margin: 0;
      padding: 0;
      color: #dcb249;
      font-size: 0.875rem;
      font-weight: 400;
      transition: all 0.3s ease;
      &:hover {
        color: #cd9e39;
      }
    }
  }
}
</style>
